exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  overflow-y: auto;\n  overflow-x: hidden;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e82cb6","scoped":false,"hasInlineConfig":false}!./~/px2rem-loader?{"remUnit":37.5,"baseDpr":1}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 622
// module chunks = 7